import { type FunctionComponent } from 'react';
import { type VideoFieldsFragment } from '../../../../__generated__/graphql-client-types';
import { PLAY_BUTTON } from '../../../../constants/videos';
import { type Media, isThreeSixtyImage, isVideo } from '../../../../helpers/images/images.helper';
import { useVideoThumbnail } from '../../../../hooks/videos/videos.hooks';
import { CloudinaryImage, type CloudinaryImageProps } from '../../../images/cloudinary-image/cloudinary-image.component';

export type CloudinaryOpts = Pick<CloudinaryImageProps, 'options' | 'variations' | 'bypassLazyLoad'>;

export type ThumbnailCardProps = {
	item: Media;
	ariaLabel: string;
	imageOptions?: CloudinaryOpts;
	className?: string;
};

export const ThumbnailCard: FunctionComponent<ThumbnailCardProps> = ({
	item,
	ariaLabel,
	imageOptions = { options: { width: 70, height: 70 } },
	className = 'pa2'
}) => {
	return (
		<div role="region" aria-label={ariaLabel} className={'mw5 center'}>
			{isVideo(item) ? (
				<ThumbnailVideoCard video={item} className={className} />
			) : isThreeSixtyImage(item) ? (
				<CloudinaryImage
					className={`db center ba br2 b--transparent pointer ${className}`}
					publicID={item.thumbnail.id}
					description={item.thumbnail.description}
					options={{ type: 'upload', ...imageOptions.options }}
				/>
			) : (
				<CloudinaryImage
					className={`db center pointer ${className}`}
					publicID={item.id}
					description={item.description}
					options={imageOptions.options}
					bypassLazyLoad={false}
				/>
			)}
		</div>
	);
};

const ThumbnailVideoCard: FunctionComponent<{ video: VideoFieldsFragment; className?: string }> = ({ video, className = 'pa2' }) => {
	const { type, thumbnailURL, isWistiaFallback } = useVideoThumbnail(video);

	return (
		<CloudinaryImage
			className={`db center pointer ${className}`}
			publicID={thumbnailURL}
			options={{
				width: 70,
				height: 70,
				type,
				crop: isWistiaFallback ? 'lpad' : 'fill',
				overlay: { publicId: PLAY_BUTTON }
			}}
			description={video.description}
		/>
	);
};
